<app-page-bar></app-page-bar>

<app-page>
  <!-- A new client (/clients/new) is an empty object: it has an id only once
       saved, as ClientPeerService.save() decides too. -->
  <mat-card *ngIf="client$ | async as client">
    <mat-card-title>
      <h2>{{client.id ? client.name : "New Client"}} {{client.company_situation ? '⚠️' : ''}}</h2>
    </mat-card-title>
    <mat-card-subtitle *ngIf="client.id">
      Created {{client.created_at|date}}
    </mat-card-subtitle>


    <mat-card-content>
      <section>

        <h3>Information</h3>

        <div class="info-grid" *ngIf="countries$ | async as countries">
          <!-- Basic Information Section -->
          <app-text label="Name">{{client.name}}</app-text>
          <app-text label="Business ID">{{client.business_id}}</app-text>
          <app-company-form-fields [entity]="client"></app-company-form-fields>
          <app-text label="Country">{{countries.get(client.country)?.name}}</app-text>
          <app-text label="Company Situation">
            <ng-container *ngIf="client.company_situation; else noSituation">
              {{client.company_situation}} <mat-icon color="warn" style="vertical-align: text-bottom;">warning</mat-icon>
            </ng-container>
            <ng-template #noSituation>-</ng-template>
          </app-text>

          <mat-divider></mat-divider>

          <!-- Financial Information Section -->
          <app-text label="In Prepayment Register">
            <ng-container [ngSwitch]="client.prepayment_register?.is_in_register">
                <span *ngSwitchCase="true">Yes</span>
                <span *ngSwitchCase="false">No</span>
                <span *ngSwitchDefault>-</span>
            </ng-container>
          </app-text>
          <app-text label="Prepayment Register Checked">{{ (client.prepayment_register?.checked_at | date:'shortDate') || 'Never' }}</app-text>
          <app-text label="Credit Limit">{{ client.credit_limit?.limit.amount | currency:'EUR' }}</app-text>
          <app-text label="Credit Limit Updated">{{ (client.credit_limit?.checked_at | date:'shortDate') || 'Never' }}</app-text>
          <app-text label="Credit Rating">{{ client.aaa_rating?.category || '-' }}</app-text>
          <app-text label="Credit Rating Updated">{{ (client.aaa_rating?.checked_at | date:'shortDate') || 'Never'}}</app-text>

          <mat-divider></mat-divider>

          <!-- Lead Information Section -->
          <app-text label="Lead Source">{{ client.lead_source?.name || '-' }}</app-text>
          <app-text label="Responsible Seller">{{ client.responsible_seller?.name || '-' }}</app-text>
        </div>
        <div class="form-actions">
            <button type="button" mat-button color="primary" (click)="openEditDialog()">Edit</button>
        </div>

      </section>
      <section>
        <h3>Bank Accounts</h3>
        <app-client-bank-accounts></app-client-bank-accounts>
      </section>
      <section *ngIf="client.id">
        <app-client-exports-widget
          [clientId]="client.id"
          [clientName]="client.name"
        ></app-client-exports-widget>
      </section>
      <section *ngIf="client.id">
        <h3>Representatives</h3>

        <div>
          <a mat-raised-button routerLink="/clients/{{client.id}}/representatives"
             title="Add Representative">Add</a>
        </div>

        <div class="mat-elevation-z4">
          <table mat-table [dataSource]="representatives$">

            <ng-container matColumnDef="first_name">
              <th mat-header-cell *matHeaderCellDef>First Name</th>
              <td mat-cell *matCellDef="let element">{{element.first_name}}</td>
            </ng-container>

            <ng-container matColumnDef="last_name">
              <th mat-header-cell *matHeaderCellDef>Last Name</th>
              <td mat-cell *matCellDef="let element">{{element.last_name}}</td>
            </ng-container>

            <ng-container matColumnDef="masked_ssn">
              <th mat-header-cell *matHeaderCellDef>Social Security Number</th>
              <td mat-cell *matCellDef="let element">{{element.masked_ssn}}</td>
            </ng-container>

            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>Email</th>
              <td mat-cell *matCellDef="let element">{{element.email}}</td>
            </ng-container>

            <ng-container matColumnDef="phone">
              <th mat-header-cell *matHeaderCellDef>Phone</th>
              <td mat-cell *matCellDef="let element">{{element.phone}}</td>
            </ng-container>

            <ng-container matColumnDef="created_at">
              <th mat-header-cell *matHeaderCellDef>Created</th>
              <td mat-cell *matCellDef="let element">{{element.created_at | date}}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element"><a
                   [routerLink]="['/clients', element.client_id, 'representatives', element.id]">
                  <mat-icon>arrow_forward</mat-icon>
                </a></td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="representativesColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: representativesColumns" matRipple
                [routerLink]="['/clients', row.client_id, 'representatives', row.id]">
            </tr>

          </table>
          <!--
          <mat-paginator [length]="representatives.total" [pageIndex]="representatives.state.pager.page - 1"
            [pageSize]="representatives.state.pager.size" [pageSizeOptions]="[5, 10, 25, 100]"
            (page)="representatives.setPage($event.pageIndex + 1, $event.pageSize)">
          </mat-paginator>
        -->
        </div>

      </section>

      <section *ngIf="client.id && documents$ | async as documents">
        <h3>Client Documents</h3>

        <mat-nav-list *ngIf="documentTypes$ | async as documentTypes">
          <mat-list-item (click)="downloadClientDocument(doc)" *ngFor="let doc of documents">
            <mat-icon mat-list-icon>description</mat-icon>
            <h4 mat-line>{{doc.name || doc.type_description}}</h4>
            <div mat-line>{{doc.filename}}</div>
            <div mat-line>{{doc.notes}}</div>
            <div mat-line>{{doc.created_at | date:'short'}}</div>
            <div mat-line>Signing status: {{doc.signing_status}}</div>
            <button mat-icon-button (click)="$event.stopPropagation()" #trigger=matMenuTrigger
                    [matMenuTriggerFor]="docMenu" [matMenuTriggerData]="{doc: doc}">
              <mat-icon>more_vert</mat-icon>
            </button>
          </mat-list-item>
          <mat-menu #docMenu="matMenu">
            <ng-template matMenuContent let-doc="doc">
              <ng-container *ngIf="!doc.signed_document">
                <button mat-menu-item (click)="openSignDocumentRequestDialog(doc)">
                  <mat-icon>approval</mat-icon>
                  <span>Sign</span>
                </button>
              </ng-container>
              <ng-container *ngIf="doc.signed_document">
                <button mat-menu-item (click)="downloadOriginalClientDocument(doc)">
                  <mat-icon>download</mat-icon>
                  <span>Download Original</span>
                </button>
              </ng-container>
              <ng-container *ngIf="canSendSignal(doc)">
                <button mat-menu-item (click)="remindSigners(doc)">
                  <mat-icon>campaign</mat-icon>
                  <span>Send Signing Reminder</span>
                </button>
              </ng-container>
              <ng-container *ngIf="canSendSignal(doc)">
                <button mat-menu-item (click)="cancelDocumentSigning(doc)">
                  <mat-icon>cancel</mat-icon>
                  <span>Cancel Signing Process</span>
                </button>
              </ng-container>
              <button mat-menu-item (click)="$event.stopPropagation()" [matMenuTriggerFor]="docTypeMenu"
                      [matMenuTriggerData]="{doc: doc}">
                <mat-icon>label</mat-icon>
                <span>Change Type</span>
              </button>
              <button mat-menu-item (click)="confirmDeleteClientDocument(doc)">
                <mat-icon>delete</mat-icon>
                <span>Delete</span>
              </button>
            </ng-template>
          </mat-menu>
          <mat-menu #docTypeMenu="matMenu">
            <ng-template matMenuContent let-doc="doc">
              <button mat-menu-item *ngFor="let docType of documentTypes"
                      (click)="changeClientDocumentType(doc, docType)">
                <span>{{ docType.description }}</span>
              </button>
            </ng-template>
          </mat-menu>
        </mat-nav-list>
        <div>
          <!--
          <button mat-raised-button>Upload</button>

            -->

          <div class="drop-zone" appFileUpload (fileAdded)="clientDocumentFileAdded(client, $event)">
            <mat-icon>cloud_upload</mat-icon>
            <div>
              <p>Drag and drop files here</p>
            </div>
          </div>
        </div>
      </section>
      <section>
        <h3>History</h3>
        <app-client-history></app-client-history>
      </section>
    </mat-card-content>
  </mat-card>

</app-page>
